module.exports = __webpack_public_path__ + "static/media/li.b378b2a5.svg";